const report = ({ mapActionToKey, types }) => {

	const [ REQUEST_REPORT, RECEIVE_REPORT, ADD_COMMENT, DELETE_COMMENT ] = types

	let tmpReport
	
	const updateReport = (state = {
			isFetching: false,
			report: []
		}, action) => {
		switch (action.type) {
			case REQUEST_REPORT:
				return {
					...state,
					isFetching: true
				}
			case RECEIVE_REPORT:
				return {
					...state,
					isFetching: false,
					report: action.payload
				}
			case ADD_COMMENT:
				tmpReport = {
					...state.report,
					commentsCount: state.report.commentsCount + 1
				}
				return {
					...state,
					report: tmpReport
				}
			case DELETE_COMMENT:
				tmpReport = {
					...state.report,
					commentsCount: state.report.commentsCount - 1
				}
				return {
					...state,
					report: tmpReport
				}
			default:
				return state
		}
	}

	return (state = {}, action) => {
		switch (action.type) {
			case ADD_COMMENT:
			case DELETE_COMMENT:
			case REQUEST_REPORT:
			case RECEIVE_REPORT:
				const key = mapActionToKey(action)
				return {
					...state,
					[key]: updateReport(state[key], action)
				}
			default:
				return state
		}
	}
}

export default report


// WEBPACK FOOTER //
// ./src/reducers/report.js